import React from 'react';
import { Flex, Form, Input, Button, List, Radio, Card, DatePicker, TimePicker, InputNumber, Divider, message } from 'antd';
import { TagOutlined, FormOutlined, DeleteOutlined } from '@ant-design/icons';
import SwitchShop from '../../shop/switch-shop';
import SelectGoods from '../../goods/select-goods';
import getCurrentShop from '../../shop/get-current-shop';
import dayjs from 'dayjs';

const iconStyle = {
    fontSize: 28,
}

export default () => {
    // const [goods, setGoods] = React.useState([]);
    const [groups, setGroups] = React.useState([]);
    const [form] = Form.useForm();  
    const [currentShop, setCurrentShop] = React.useState(null);
    const [currentShopId, setCurrentShopId] = React.useState(null);
    const [shopId, setShopId] = React.useState(null);
    const selectedGoods = Form.useWatch('goodsId', form);
    const urlParams = new URLSearchParams(window.location.search);
    const groupTmpId = urlParams.get('groupTmpId');
    const isEdit = !!groupTmpId;
    const view = urlParams.get('action') === 'view';
    
    React.useEffect(() => {
        const fetchShop = async () => {
            const shop = await getCurrentShop();
            setCurrentShop(shop);
            setCurrentShopId(shop?.shopId);
            setShopId(shop?.shopId);
        };
        
        fetchShop();
    }, []);
    
    React.useEffect(() => {
        if (currentShopId) {
            if(groupTmpId) {
                initForm(groupTmpId);
            }else{
                form.setFieldsValue({
                    duration: 24,
                    allowedRegion: 'CITY',
                });
            }
            
            // getGoodsList();
        }
    }, [currentShopId]);

    const initForm = async () => {
        const url = `/api/promotion/group-buy-template/detail?groupTmpId=${groupTmpId}&shopId=${shopId}`;
        const response = await fetch(url);
        const result = await response.json();

        if(result && result.success) {
            const data = result.data;
            const goodsId = data.goodsId;

            let goods = await fetch(`/api/goods/detail?goodsId=${goodsId}`);
            goods = await goods.json();
            goods = goods.data;

            console.log('initForm', data);
            form.setFieldsValue({
                ...data,
                goodsId: [goods],
                startDate: dayjs(data.startTime),
                endDate: dayjs(data.endTime),
                startTime: dayjs(data.startTime),
                endTime: dayjs(data.endTime),
                skus: data.skus.map(item => ({
                    ...item,
                    discount: item.discount,
                })),
            });
        }
    }

    const requestUpdate = async (values) => {
        console.log(values);
        let url = '/api/promotion/group-buy-template/create';

        if(groupTmpId && shopId){
            url = `/api/promotion/group-buy-template/edit?groupTmpId=${groupTmpId}&shopId=${shopId}`;
        }

        const response = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(values),
        });

        const result = await response.json();
        if(result && result.success) {
            message.success('提交成功');
            setTimeout(() => {
                window.location.href = '/promotion/group-buy';
            }, 200);
        } else {
            message.error(result.data);
        }
    }
    const onSubmit = () => {
        form.validateFields().then(values => {
            
            values = {
                ...values,
                // 合并startDate和startTime
                startTime: dayjs(values.startDate).format('YYYY-MM-DD') + ' ' + dayjs(values.startTime).format('HH:mm:ss'),
                endTime: dayjs(values.endDate).format('YYYY-MM-DD') + ' ' + dayjs(values.endTime).format('HH:mm:ss'),
                goodsId: values.goodsId?.[0]?.goodsId,
                shopId: currentShopId,
                allowedRegion: values.allowedRegion || 'ALL',
            }

            requestUpdate(values);
        }).catch(err => {
            console.log(err);
        })
    }

    return (
        <div>
            <SwitchShop />
            
            <h2 className="admin-page-title">{isEdit ? '编辑' : '创建'}团购</h2>
            
            <div className="admin-form-container">
                <Form form={form} layout="vertical" disabled={view ? true : false}>
                <Form.Item
                    label="团购名称"
                    name="title"
                    rules={[{ required: true, message: '请输入团购名称' }]}
                >
                    <Input />
                </Form.Item>

                <Form.Item
                    label="描述"
                    name="discription"
                >
                    <Input />
                </Form.Item>

                <Form.Item 
                    label="适用商品"
                    name='goodsId'
                    rules={[{required: true, message: '至少选择一个商品'}]}
                >
                    <SelectGoods />
                </Form.Item>

                <Form.List name='skus'>
                    {
                        (fields, {add, remove}) => (
                            <>
                                <Form.Item label="配置团购" rules={[{required: true, message: '至少添加一个配置'}]}>
                                    {
                                        fields.length > 0 && fields.map(({key, name}, index) => {
                                            const originPrice = selectedGoods?.[0]?.price;
                                            const unit = selectedGoods?.[0]?.unit;

                                            return (
                                                <Flex key={key} gap={10} align='center' justify='start'>
                                                    <Form.Item name={[name, 'num']}><InputNumber placeholder='成团数' addonAfter='人团' /></Form.Item>
                                                    <Form.Item name={[name, 'discount']}><InputNumber placeholder='折扣' addonAfter='%' /></Form.Item>
                                                    {/* { originPrice && 
                                                        <div style={{fontSize: '12px', lineHeight: 1.1, marginBottom: '10px'}}>
                                                            原价{originPrice/100}元
                                                        </div>} */}
                                                    <div onClick={() => remove(name)}><DeleteOutlined size={'large'} /></div>
                                                </Flex>
                                            )
                                        })
                                    }
                                    <div style={{margin: '-10px 0 0 0'}} onClick={() => add()}><a>增加配置</a></div>
                                </Form.Item>
                            </>
                        )
                    }
                </Form.List>

                <Form.Item
                    label="成团时间"
                    name="duration"
                    rules={[{ required: true, message: '请输入结束时间' }]}
                >
                    <InputNumber addonAfter='小时' addonBefore='开团后' />
                </Form.Item>

                <Form.Item label="成团范围限制" name={'allowedRegion'} help="指同一范围内才能加入同一团，注意范围越小越难成团"
                    rules={[{ required: true, message: '请选择范围限制' }]}
                >
                    <Radio.Group optionType='button'>
                        <Radio value='ALL'>不限制</Radio>
                        <Radio value='PROVINCE'>省内</Radio>
                        <Radio value='CITY'>市内</Radio>
                        <Radio value='COUNTY'>区内</Radio>
                        <Radio value='COMMUNITY'>小区内</Radio>
                    </Radio.Group>
                </Form.Item>
                

                <Flex justify='start' gap={10}>
                    <Form.Item
                        label="团购开始日期"
                        name="startDate"
                        rules={[{ required: true, message: '请输入开始时间' }]}
                    >
                        <DatePicker 
                            changeOnScroll={true}
                            needConfirm={false}
                            showNow={true}
                        />
                    </Form.Item>

                    <Form.Item
                        label="开始时间"
                        name="startTime"
                        rules={[{ required: true, message: '请输入结束时间' }]}
                    >
                        <TimePicker format="HH:mm" 
                            changeOnScroll={true}
                            needConfirm={false}
                            showNow={true}
                        />
                    </Form.Item>
                </Flex>

                <Flex justify='start' gap={10}>
                    <Form.Item
                        label="团购结束日期"
                        name="endDate"
                        rules={[{ required: true, message: '请输入开始时间' }]}
                    >
                        <DatePicker 
                            changeOnScroll={true}
                            needConfirm={false}
                            showNow={true}
                        />
                    </Form.Item>

                    <Form.Item
                        label="结束时间"
                        name="endTime"
                        rules={[{ required: true, message: '请输入结束时间' }]}
                    >
                        <TimePicker format="HH:mm" />
                    </Form.Item>
                </Flex>

                {/* <Form.Item
                    label="最小成团数"
                    name="minGroupNum"
                    rules={[{ required: true, message: '请输入最小成团数' }]}
                >
                    <InputNumber />
                </Form.Item> */}
                
                <div className="admin-form-actions">
                    <Button type="default">取消</Button>
                    <Button type="primary" onClick={onSubmit}>提交</Button>
                </div>
            </Form>
        </div>
    </div>
    )
}